export enum AgentType {
  iPhone = 1,
  iPad = 2,
  AndroidPhone = 3,
  AndroidTablet = 4,
  WindowsPC = 5,
  Other = 6,
  Macintosh = 7,
}
